import { createStore } from 'vuex'
import persistedStateVuex from "persisted-state-vuex";



export default createStore({
  state: {
    isCollapse: false,
    isLoading: false,
    jwtToken: null,
    currentSessionUserID: null,
    currentSessionRailsID: null,
    currentSessionRailsData: null,
    currentUserSession: null,
    currentSessionEmail: null,
    currentSessionFirstname: null,
    currentSessionLastname: null,
    fedexAccessToken: null,
    orderListStorage: [],
    loginType: null,
    origin: 'Portal',
    currentOrderDetails: null,
    currentShipstationDetails: null,
    providedVins: [],
    p2b7cc318da9ba9d03912592c2f34a1ec: null
  },
  mutations: {
    SET_SIDEBAR_TOGGLE: function (state, isCollapse) {
      state.isCollapse = isCollapse;
    },
    TOGGLE_FULLSCREEN_SPINNER: function (state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_JWT_TOKEN: function (state, jwtToken) {
      state.jwtToken = jwtToken;
    },
    SET_SESSION_USER_ID: function (state, currentSessionUserID) {
      state.currentSessionUserID = currentSessionUserID;
    },
    SET_SESSION_RAILS_ID: function (state, currentSessionRailsID) {
      state.currentSessionRailsID = currentSessionRailsID;
    },
    SET_SESSION_RAILS_DATA: function (state, currentSessionRailsData) {
      state.currentSessionRailsData = currentSessionRailsData;
    },
    SET_SESSION_TYPE: function (state, currentUserSession) {
      state.currentUserSession = currentUserSession;
    },
    SET_SESSION_EMAIL: function (state, currentSessionEmail) {
      state.currentSessionEmail = currentSessionEmail;
    },
    SET_FEDEX_TOKEN: function (state, fedexAccessToken) {
      state.fedexAccessToken = fedexAccessToken;
    },
    SET_ORDER_LIST_STORAGE: function (state, orderListStorage) {
      state.orderListStorage = orderListStorage;
    },
    SET_LOGIN_TYPE: function (state, loginType) {
      state.loginType = loginType;
    },
    SET_ORIGIN: function (state, origin) {
      state.origin = origin;
    },
    SET_CURRENT_ORDER_DETAILS: function (state, currentOrderDetails) {
      state.currentOrderDetails = currentOrderDetails;
    },
    SET_CURRENT_SHIPSTATION_DETAILS: function (state, currentShipstationDetails) {
      state.currentShipstationDetails = currentShipstationDetails;
    },
    SET_PROVIDED_VIN: function (state, providedVins) {
      state.providedVins = providedVins;
    },
    SET_CURRENT_SESSION_FIRSTNAME: function (state, currentSessionFirstname) {
      state.currentSessionFirstname = currentSessionFirstname;
    },
    SET_CURRENT_SESSION_LASTNAME: function (state, currentSessionLastname) {
      state.currentSessionLastname = currentSessionLastname;
    },
    SET_USER_PASS: function (state, p2b7cc318da9ba9d03912592c2f34a1ec) {
      state.p2b7cc318da9ba9d03912592c2f34a1ec = p2b7cc318da9ba9d03912592c2f34a1ec;
    }
  },
  getters: {

  },
  actions: {

  },
  modules: {

  },
  plugins: [persistedStateVuex.init],
})
